import React from 'react';
import { ButtonTemplateProps } from '..';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Icon } from '../../../icons';
import { IconType } from '../../../icons/Icon';

import { Button, ButtonVariant } from '../Button';

interface CreateButtonProps extends ButtonTemplateProps {}

export default function CreateButton(props: CreateButtonProps) {
  return (
    <Button
      {...props}
      leading={<Icon type={IconType.plus} size={'h-5 w-5'} />}
      text={props.text || t(TranslationKey.create).singular.upper}
      variant={ButtonVariant.primary}
    />
  );
}
